















import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogBox from '@/components/dialog-box/DialogBox.vue';

@Component({
  components: { DialogBox }
})
export default class ErrorDialog extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;
  @Prop({ default: 'Une erreur est survenue.' }) text: string;
  @Prop({ default: 'Fermer' }) closeText: string;

  close() {
    this.$emit('close');
  }
}
